type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const credits = {
  website: 'https://stackbros.in/',
  name: 'Stackbros',
  buyLink: '',
}

export const basePath: string = ''
